<!--
 * @Author: MouXiaowei
 * @Date: 2022-05-26 14:24:02
 * @Description: 邮储银行数字人民币红包活动-红包使用说明
-->
<template>
  <div class="home-box">
    <div class="img-box">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_redpaper_explain1_green.png" alt="">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_redpaper_explain2_green.png" alt="">
    </div>
  </div>
</template>
<script>

export default {
  components: {

  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.home-box {
  position: relative;
  min-height: 100vh;
}
.img-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 100%;
    }
}
</style>
